const SERVICE_NAME_KEY = 'service.name';
const ENVIRONMENT_KEY = 'deployment.environment';
const SERVICE_NAME = 'angular-ionic-frontend';
const SIGNOZ_INGESTION_KEY_HEADER = 'signoz-ingestion-key';
const TRACE_ENDPOINT = '/v1/traces';
const LOG_ENDPOINT = '/v1/logs';

export {
  SERVICE_NAME_KEY,
  ENVIRONMENT_KEY,
  SERVICE_NAME,
  SIGNOZ_INGESTION_KEY_HEADER,
  TRACE_ENDPOINT,
  LOG_ENDPOINT,
};
